import { render, staticRenderFns } from "./DateInterval.vue?vue&type=template&id=72f8915c&"
import script from "./DateInterval.vue?vue&type=script&lang=js&"
export * from "./DateInterval.vue?vue&type=script&lang=js&"
import style0 from "./DateInterval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports